import {
  ISingleOperationPayload,
  IOperationHandlerThunkAction
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import {
  IItemCacheDispatch,
  IItemCacheThunkAction
} from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { ISpPageContext } from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';
import { spPageContextKeyFacet, spPageContextForDataRequestorKeyFacet } from '../Keys';
import { spPageContextFacet, spPageContextForDataRequestorFacet } from '../Facets';
import { Locale } from '@ms/items-view-utilities/lib/locale/Locale';
import { initAriaLogging } from '../../utilities/logging/ItemScopeAriaLogger';
import { ItemResolver } from '@ms/items-view/lib/private/models/items/ItemResolver';
import { getAuthToken } from '../getData';

/**
 * @public
 */
export function updatePageContext(
  payload: ISingleOperationPayload<typeof spPageContextKeyFacet.type, {
    pageContext: ISpPageContext
  }>
): IOperationHandlerThunkAction {
  const {
    itemKey,
    options: {
      pageContext
    }
  } = payload;
  return async (dispatch: IItemCacheDispatch) => {
    const finalPageContext: ISpPageContext = {
      ...pageContext,
      ...(!pageContext.authToken && !pageContext.getAuthToken ? {
        getAuthToken: async () => {
          const authToken = await dispatch(getAuthToken({
            url: pageContext.webAbsoluteUrl
          }));

          return authToken || '';
        }
      } : {})
    };

    const itemResolver = new ItemResolver();

    itemResolver.resolveItems({
      items: {
        [itemKey]: {
          ...spPageContextFacet.pack(finalPageContext)
        }
      }
    });

    itemResolver.merge(dispatch(updatePageContextForDataRequestor({
      itemKey,
      options: {
        pageContext: finalPageContext
      }
    })).itemResolver);

    dispatch(itemResolver.execute());

    const language = pageContext.currentUICultureName || pageContext.currentCultureName || 'en-US';

    if (Locale.language !== language) {
      Locale.invalidate(language, pageContext.currentLanguage);
    }

    dispatch(initAriaLogging(pageContext));
  };
}

function updatePageContextForDataRequestor(
  payload: ISingleOperationPayload<typeof spPageContextKeyFacet.type, {
    pageContext: ISpPageContext
  }>
): IItemCacheThunkAction<{
  itemResolver: ItemResolver;
}> {
  const {
    itemKey,
    options: {
      pageContext
    }
  } = payload;
  return (dispatch: IItemCacheDispatch) => {
    const itemResolver = new ItemResolver();

    const {
      webAbsoluteUrl
    } = spPageContextKeyFacet.deserialize(itemKey);
    if (pageContext) {
      const pageContextForDataRequestorKey = spPageContextForDataRequestorKeyFacet.serialize({
        webAbsoluteUrl: webAbsoluteUrl
      });

      itemResolver.resolveItems({
        items: {
          [pageContextForDataRequestorKey]: {
            ...spPageContextForDataRequestorFacet.pack(pageContext)
          }
        }
      });
    }

    return {
      itemResolver
    };
  };
}
